import React, { useState, useRef, useEffect } from 'react';
import './MenuBar.css';

const menuData = [
  {
    label: 'Archivo',
    items: [
      { label: 'Biblioteca de Documentos', hasSubmenu: true },
      { label: 'Nuevo', hasSubmenu: true, submenuItems: [
        { label: 'International Norms', hasSubmenu: true },
        { label: 'SIDUNEAWorld', hasSubmenu: true, submenuItems: [
          { label: 'Arancel Integrado', hasSubmenu: true },
          { label: 'Manifiesto de Carga', hasSubmenu: true },
          { label: 'Tablas de Referencia', hasSubmenu: true },
        ]},
        { label: 'Mi Perfil' },
      ]},
      { type: 'separator' },
      { label: 'Salir', shortcut: 'Ctrl+Alt+X' },
    ],
  },
  {
    label: 'Ver',
    items: [
      { label: 'Biblioteca de Documentos' },
      { label: 'Correo Electrónico' },
      { label: 'Barra de Herramientas' },
      { label: 'Barra de Tareas' },
    ],
  },
  {
    label: 'Ventana',
    items: [
      { label: 'Nueva ventana' },
      { label: 'Cerrar ventana' },
    ],
  },
  {
    label: 'Ayuda',
    items: [
      { label: 'Acerca de' },
    ],
  },
];

// Componente recursivo para renderizar items con submenús anidados
function SubmenuItems({ items, onItemClick, openSubmenus, setOpenSubmenus, depth = 0 }) {
  return (
    <>
      {items.map((item) => (
        <div
          className="menubar-dropdown-item-wrapper"
          key={item.label}
          onMouseEnter={() => {
            const newOpen = { ...openSubmenus };
            // Limpiar submenús del mismo nivel y más profundos
            Object.keys(newOpen).forEach((key) => {
              if (parseInt(key) >= depth) delete newOpen[key];
            });
            if (item.submenuItems) {
              newOpen[depth] = item.label;
            }
            setOpenSubmenus(newOpen);
          }}
        >
          <button
            className={`menubar-dropdown-item ${openSubmenus[depth] === item.label ? 'hovered' : ''}`}
            onClick={() => !item.submenuItems && onItemClick(item.label)}
          >
            <span>{item.label}</span>
            {item.shortcut && (
              <span className="menubar-shortcut">{item.shortcut}</span>
            )}
            {item.hasSubmenu && (
              <span className="menubar-submenu-arrow">►</span>
            )}
          </button>
          {item.submenuItems && openSubmenus[depth] === item.label && (
            <div className="menubar-submenu">
              <SubmenuItems
                items={item.submenuItems}
                onItemClick={onItemClick}
                openSubmenus={openSubmenus}
                setOpenSubmenus={setOpenSubmenus}
                depth={depth + 1}
              />
            </div>
          )}
        </div>
      ))}
    </>
  );
}

function MenuBar({ onAction }) {
  const [openMenu, setOpenMenu] = useState(null);
  const [openSubmenus, setOpenSubmenus] = useState({});
  const menuBarRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (menuBarRef.current && !menuBarRef.current.contains(e.target)) {
        setOpenMenu(null);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleMenuClick = (index) => {
    setOpenMenu(openMenu === index ? null : index);
    setOpenSubmenus({});
  };

  const handleMenuHover = (index) => {
    if (openMenu !== null) {
      setOpenMenu(index);
    }
  };

  const handleItemClick = (menuLabel, itemLabel) => {
    console.log(`Clicked: ${menuLabel} > ${itemLabel}`);
    setOpenMenu(null);
    if (onAction) onAction(itemLabel);
  };

  return (
    <div className="menubar" ref={menuBarRef}>
      {menuData.map((menu, index) => (
        <div className="menubar-item" key={menu.label}>
          <button
            className={`menubar-button ${openMenu === index ? 'active' : ''}`}
            onClick={() => handleMenuClick(index)}
            onMouseEnter={() => handleMenuHover(index)}
          >
            {menu.label}
          </button>
          {openMenu === index && (
            <div className="menubar-dropdown">
              {menu.items.map((item, i) =>
                item.type === 'separator' ? (
                  <div className="menubar-separator" key={`sep-${i}`} />
                ) : (
                  <SubmenuItems
                    key={item.label}
                    items={[item]}
                    onItemClick={(label) => handleItemClick(menu.label, label)}
                    openSubmenus={openSubmenus}
                    setOpenSubmenus={setOpenSubmenus}
                    depth={0}
                  />
                )
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default MenuBar;
